<template>
  <div id="top1s" >
   
  
  
    <loading
      :active="isWorking"
      :can-cancel="false"
      :is-full-page="true"
    />
    <!----
    <pincelTable
            v-if="show_paint_objects"
            :pincelData="paintObjects"
            :viewer_id="id"
            :task="task"
            style="position:absolute; z-index: 32434;width: 40vw;left:45px; display:none"
            
            
         
    /> -->
   



    <div style="display:flex;justify-content: center;position: relative;">
    
      <div
        id="viewer"
        ref="viewer"
        style="viewer"
      >
        <div id="head" style="position:relative;  display: grid;">
          <div id="buttons" style="height:37px" >
            <b-button
              variant="outline-gray"
              style="margin-right: 5px"
              @click="zoom(1.1)"
              :disabled="edit_role == 0 || active_paint"
            >
              <feather-icon
                icon="ZoomInIcon"
                style="margin: 0 5px;"
              />
            </b-button>
            <b-button
              variant="outline-gray"
              style="margin-right: 5px"
              @click="zoom(0.9)"
              :disabled="edit_role == 0 || active_paint"
            >
              <feather-icon
                icon="ZoomOutIcon"
                style="margin: 0 5px;"
              />
            </b-button>
            <b-button
              variant="outline-gray"
              style="margin-right: 5px"
              :disabled="(!disabled || markerSelected.length === 0) && (markerTit !== 'ROUNDS') || active_paint"
              @click="resetImgAll()"
            >
              <feather-icon
                icon="RefreshCcwIcon"
                style="margin: 0 5px;"
              />
            </b-button>
            <b-button
              v-if="1 === 2"
              variant="outline-gray"
              style="margin-right: 1px"
              :disabled="edit_role == 0"
            >
              <feather-icon
                icon="CropIcon"
                style="margin: 0 5px;"
              />
            </b-button> 
            <!-- <b-button
              :disabled="(!disabled || markerSelected.length === 0) && (markerTit !== 'ROUNDS')"
              variant="outline-gray"
              style="margin-right: 5px"
              @click="refresh()"
            >
              REFRESH IMAGE
            </b-button> -->
            <b-button
              :disabled="(!disabled || markerSelected.length === 0) && (markerTit !== 'ROUNDS')"
              variant="outline-gray"
              style="margin-right: 1px"
              @click="downloadImg()"
            >
              <feather-icon
                icon="DownloadIcon"
                style="margin: 0 5px;"
              />
            </b-button>
            
           


            

            <!-- <b-button
              :disabled="img == ''"
              variant="outline-gray"
              style="margin-right: 1px;"
              @click="activePaint()"
            >
              <feather-icon
                icon="EditIcon"
                style="margin: 0 5px;"
              />
            </b-button> -->
            <b-button
              :disabled="img == ''"
              variant="outline-gray"
              style="margin-right: 1px;"
              @click="showPaintObjects()"
            >
              <feather-icon
                icon="EyeIcon"
                style="margin: 0 5px;"
              />
            </b-button>
            <b-button
              :disabled="img == ''"
              variant="outline-gray"
              style="margin-right: 1px;"
              @click="show_thumber()"
            >
             Thumbnail
            </b-button>
            <b-button
              :disabled="true"
              variant="outline-gray"
              style="margin-right: 1px; background-color: blue; color:white;right: 0 !important;position: absolute;padding: 8px !important"
            
            >
              {{actual_paint_mode}}
          
            </b-button>
             <b-button 
                  v-show="tabId != id"
                  
                  variant="gradient-danger"
                  class="btn-icon rounded"
                  size="sm"
                  style="margin: 1px 3px;"
              
                  @click="remove_popup()"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
           
          </div>
         
          <div id="slides" style="height:37px;position:relative;" >
             <v-select
              v-model="type"
              :options="types"
              placeholder="Type"
              :searchable="true"
              :disabled="edit_role == 0 "
              style="width: 150px; margin-right:1px;height: 37px;"
            />
            
             <v-select
              v-model="dig_rec"
              v-show="type == 'Digital_Reconstruction' || type == 'Dig_Reconst'"
              :options="dig_recs"
              placeholder="Reconstruction"
              :searchable="true"
              :disabled="edit_role == 0 || active_paint"
              style="width: 100px; margin-right:1px"
            />  
            <v-select
              v-model="slide"
              :options="Object.keys(slides)"
              placeholder="Slide"
              :searchable="true"
              :disabled="edit_role == 0 || active_paint"
              style="width: 150px; margin-right:3px"
            />
            <!--  <v-select
              v-model="patient_id"
              :options="patient_ids"
              placeholder="ID"
              :searchable="true"
              :disabled="edit_role == 0 || active_paint"
              style="width: 120px; margin-right:3px"
            />-->
           
            
            <v-select
              v-model="scene"
              :options="scenes"
              placeholder="Scene"
              :searchable="true"
              :disabled="edit_role == 0 || active_paint"
              style="width: 160px; margin-right:3px"
            />
           
            

            <b-button
              variant="outline-gray"
              style="margin-right: 5px"
              @click="changeSceneClick(-1)"
              :disabled="edit_role == 0 || active_paint"
            >
              <feather-icon
                icon="ArrowLeftIcon"
                style="margin: 0 3px;"
              />
            </b-button>
            <b-button
              variant="outline-gray"
              style="margin-right: 5px"
              @click="changeSceneClick(1)"
              :disabled="edit_role == 0 || active_paint"
            >
              <feather-icon
                icon="ArrowRightIcon"
                style="margin: 0 3px;"
              />
            </b-button>
              <!-- <b-button
           
              variant="outline-gray"
              style="margin-right: 0px;padding: 3px;"
              @click="show_all_settings()"
            >
            {{show_label }}
          
             </b-button> -->
             <b-button
              v-show="type == 'AFS_QC' || type == 'REG_Markers_QC' "
              :disabled="markerTit != 'MARKERS' || edit_role == 0"
              variant="outline-gray"
              style="margin-left: 1px;width:auto;margin-left: 1px;width: auto;height: 32px;margin: 2px 3px !important;right: 0 !important;position: absolute;padding: 1 1 15px !important;"
              @click="show_marker_popup()"
    
              name="Markers"
            >
            
              <svg
        height="10"
        width="10"
            >
              <circle
                cx="5"
                cy="5"
                r="5"
                fill="red"
              />
            
      </svg>
          Markers
            </b-button>
             <b-button
              v-show="type != 'AFS_QC' && type != 'Dig_Reconst' && type != 'REG_Markers_QC' && type != 'SEG_QC' && type != 'H_E_images'"
              :disabled="markerTit != 'ROUNDS'"
              variant="outline-gray"
              style="margin-right: 5px"
              @click="show_rounds_popup()"
            >
            rounds
             </b-button>
          </div>
         
          <div id="settings-content" :v-show ="edit_role == 3" >
            <b-button
              variant="outline-gray"
              style="margin-right: 7px;"
              @click="manageSettings()"
            >
              <feather-icon
                icon="SettingsIcon"
                style="margin: 0 5px;"
              />
            </b-button>
            <div :class="{markerDisabled: (type === 'REG_QC')}">
              <span v-if="type !== 'REG_QC'">{{ markerTit }}</span>
            </div>
          </div>
        </div>
       
        <div id="content" >
          <loading
            :active="isLoading"
            :can-cancel="false"
            :is-full-page="false  "
          />
          <div >
         
              <canvas v-show="active_paint" id="top1" :id="'canvas' + task" class="canvas-pict" :ref="'canvas' + task"  :style="' height: 40vw;width: 40vw !important;background-image: url(' + img+ '); border: 1px solid black; background-size: 100% 100%;' "   @mousedown="startDrawing($event)" @mousemove="continueDrawing($event)" @mouseup="endDrawing($event)"></canvas>
              <div v-b-tooltip.hover.left.v-primary  id="toop" v-show="paint_tooltip.name != undefined && tooltip_display == true" >
                <!-- -->
        
        <b-button style="background-color:#F5F5F5 !important; color:grey !important">
              
                <svg
          height="10"
          width="10"
              >
                <circle
                  cx="5"
                  cy="5"
                  r="5"
                  :fill="paint_tooltip.color"
                />
              
        </svg>
            {{ paint_tooltip.name}} 
              </b-button>
       
      </div>
            </div>
          <div v-show="!active_paint" id="picture" style="position: relative;" @mousedown="is_moving(true, $event)">
            <cropper
              ref="cropper"
              class="cropper"
              :src="img"
              :stencil-props="stencilProps"
              :default-position="defaultPosition"
              :default-size="defaultSize"
              :image-restriction="imageRestriction"
              :resize-image="true"
              :move-image="true"
              @change="cropChange"
              @ready="imgReady"
            

            />
            <div
          v-if="imageSize !== null &&  img != ''"
          class="floatingMap"
        >
    
          <div
            class="minmap"
            v-show="!active_paint && show_th && img_thumb != '' && img != ''"
          
            :style="`width: ${minSize[0] + 20}px; height: ${minSize[1] + 20}px`"
          >
        
            <!-- <div
              class="miniatura"
              :src="img"
              :style="`width: ${minSize[0]}px; height: ${minSize[1]}px`"
            /> -->
        
               <img v-bind:src="img_thumb" class="miniatura" :style="`width: ${minSize[0]}px; height: ${minSize[1]}px`">
            <div
              class="miniatura_delimit"
             
          
              :style="`width: ${Math.min(minRegion[2] - minmap[2], minSize[0]) }px; height: ${Math.min(minRegion[3] - minmap[3], minSize[1])}px; margin-left: ${Math.max(minRegion[0] + minmap[0], 0)}px; margin-top: ${Math.max(minRegion[1] + minmap[1], 0)}px`"
            />
          </div>
          
        </div>
         
          </div>
        
   
           <div
            v-if="show_paint_objects && !show_color_modal"
            id="paint-content"
          
            style="max-height: 40vw;"
          > 
          <b-table
          style="display:none"
            :responsive="true"
            hover
            :fields="fields"
            :items="paintObjects"
          >
         
          <template #cell(selected)="data">
            <b-form-checkbox
                v-model="data.value"
                class="custom-control-secondary"
                @change="selectPaintObjects(data.item.name, data.item.id, data.item.color)"
             
              >
         
            </b-form-checkbox>
             
            </template>
            <template #cell(color)="data">
              <div style="margin-top: 10px;">
             <h4> <input-color-picker
                  v-model="data.value"
                  @input="updateValue(data.item.id, data.value, data.item.name)"

                /> </h4>

                </div>

   
             
            </template>
            <template #cell(name)="data">
              
              <input type="text" v-model="data.value" style="border:0px;background-color: transparent;"  @input="updateValue(data.item.id, data.item.color, data.value)">
            </template>
            <template
              #cell(remove)="data" 
             
            >
          
              <div
                style="text-align: center; width:100%;cursor: pointer"
              >
                <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="close-btn delSlide"
                  @click="removeObject(data.item.id)"
                /></div>
            </template>
            <template  #cell(show_square)="data" >
              <b-form-checkbox
                v-model="data.value"
                class="custom-control-secondary"
                @change="showSquareObject(data.item.id, data.value)"
             
              >
            </b-form-checkbox>
        

            </template>
            <template  #cell(draw_inside)="data" >
              <b-form-checkbox
                v-model="data.value"
                class="custom-control-secondary"
                @change="drawInside(data.item.id, data.value)"
             
              >
            </b-form-checkbox>
       

            </template>
          </b-table>
            <div style="align-items:right; position:absolute; right: 10px; top:5px">
              <b-button
                variant="primary"
                size=""
                class=""
                right:0
                float:rigth
                style="border:0px !important; padding:1.8px 2px !important"
            
                
                :disabled="edit_role == 0"
                @click="refresh_only();hiddenPaintObjects()"
              >
              <feather-icon
                      icon="RefreshCcwIcon"
                      style="margin: 0 5px;"
                    />
              
              </b-button>
            </div>
            <div style="margin-top:20px">
            
              <div
              v-for="(item, i) in paintObjects"
              :key="i"
            > 
        
      
            <div v-show="item.is_first == 1" style="margin-left:7px; ">
            
              <strong>{{  item.object_type }}</strong> <br>
            </div>
            <div class="paint">
            <b-form-checkbox
                v-model="item.selected"
                class="custom-control-secondary"
                @change="selectPaintObjects(item.name, item.id, item.color)"
             
              />
              <div >
            <input-color-picker
                  v-model="item.color"
                  @input="updateValue(item.id, item.color, item.name)"

                /> 

                </div>
                <div>
                  <input type="text" v-model="item.name" style="border:0px;background-color: transparent;width:100px; font-size:12px"  @input="updateValue(item.id, item.color, item.name)">

                </div>
              
                <div>
                  <b-form-checkbox
                v-model="item.draw_inside"
                class="custom-control-secondary"
                label="Draw"
                @change="drawInside(item.id, item.draw_inside)"
             
              ><div style="margin-bottom: 0px;color: grey;font-size:11px;">
                Draw
              </div> 
              <div>
                
              </div>
            </b-form-checkbox>
                </div>
                <div style="margin-left:6px">
                  <b-form-checkbox
                v-model="item.show_square"
           
                title="Square"
                class="custom-control-secondary"
                @change="showSquareObject(item.id, item.show_square)"
                style="margin-left:3px"
             
              ><div style="margin-bottom: 0px;color: grey;font-size: 11px;">
                Square
              </div> 
            </b-form-checkbox>
                </div>
                <div
                style="text-align: center; width:100%;cursor: pointer;padding: 4px;margin-left:4px"
              >
              <b-button 
               
                  variant=""
                  class="btn-icon rounded"
                  size=""
                  style="padding: 1px;"
              
                  @click="removeObject(item.id)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              
                
              </div>
              
           
        
                

             
               <!-- <div style="margin-left:5px"
                class="marker-title"
              >
              {{ item.name }}</div> -->
              <!-- <b-button
              :disabled="img == ''"
              variant="outline-white"
              style="padding: 0px !important;margin-left:2px"
              @click="showSquareObject(item.id)"
            >
              <feather-icon
                icon="EyeIcon"
                style="margin: 0px !important;"
              />
            </b-button> -->
            </div>  
          </div> 

            </div>
      
            
          
        </div>
          <div
            v-if="show_color_modal"
            id="paint-content"
            
          
          >
      
            <div
              v-for="(item, i) in paintList"
              :key="i"
              class="paint"
            > <b-form-checkbox
                :v-model="true"
                :value="true"
                class="custom-control-secondary"
                @change="setPaintMode(item.name, item.color)"
              />
              <input-color-picker
                v-model="item.color"
                @change="colorPickerChange(item.color, item.name)" 
                @update="colorPickerChange(item.color, item.name)"
                @mousedown="colorPickerChange(item.color, item.name)"
              /> 
              <!-- <div
                class="paint-color"
                :style="`background: ${item.color}`"
                @click="editPaintColor(item.name)"
              
              /> -->
               <div
                class="marker-title"
                @click="editMarker(item.name, item.path)"
              >{{ item.name }}</div>
            </div>
          </div> 
         
        
  
          <div
            v-if="markerTit === 'MARKERS' && marker_popup "
            id="marker-content"
            :key="updateMarkers"
          >
     
          
            <div
              v-for="(item, i) in markers"
              :key="i"
              class="marker"
          
            > <b-form-checkbox
                v-model="markerSelected"
                :value="item.path"
                class="custom-control-secondary"
              />
           
              <div
                :class="{ pointer : (markerSelected.includes(item.path))}"
                class="marker-color"
                :style="`background: ${item.color}`"
                @click="editMarker(item.name, item.path)"
              /> <div
                :class="{ pointer : (markerSelected.includes(item.path))}"
                class="marker-title"
                @click="editMarker(item.name, item.path)"
              >{{ item.name }}</div></div>
          </div> 
           <div
            v-if="markerTit === 'ROUNDS'"
            id="marker-content"
            :key="updateMarkers"
            :class="{markerDisabled: (type === 'REG_QC')}"
            @click="show_rounds_pop()"
          >
            <div
              v-if=" scene !== null"
              style="margin:5px;"
              v-show="rounds_popup"
            >
            ROUNDS
              <b-form-select
                id="rounds"
                v-model="roundSelected"
                :options="rounds"
                size="sm"
              />
              <div style="display:flex; margin:10px;justify-content: center;">
                <b-button
                  variant="outline-gray"
                  style="margin-right: 5px"
                  @click="changeRound(-1)"
                >
                  <feather-icon
                    icon="ArrowLeftIcon"
                    style="margin: 0 5px;"
                  />
                </b-button>
                <b-button
                  variant="outline-gray"
                  style="margin-right: 5px"
                  @click="changeRound(1)"
                >
                  <feather-icon
                    icon="ArrowRightIcon"
                    style="margin: 0 5px;"
                  />
                </b-button>
              </div>
            </div>
          </div> 
         <div
            v-show="edit_role == 3"
            v-if="markerTit === 'SETTINGS'"
            id="settings-content"
          >
            <b-form-group
              label="Legend Position"
              label-for="legend"
            >
              <b-form-select
                id="legend"
                v-model="legend"
                :options="legendOptions"
                size="sm"
              />
            </b-form-group>
            <b-form-group
              label="Scale"
              label-for="scale"
            >
              <b-form-spinbutton
                id="scale"
                v-model="scale"
                step="0.1"
                min="0"
                max="1"
              />
            </b-form-group>
            <b-form-group
              label="Scale Position"
              label-for="scalepos"
            >
              <b-form-select
                id="scalepos"
                v-model="scalepos"
                :options="scaleposOptions"
                size="sm"
              />
            </b-form-group>
            <b-button
              variant="outline-gray"
              style="margin-right: 5px"
              @click="saveSettings()"
            >
              SAVE SETTINGS
            </b-button>
          </div>
        </div>
       
        
      </div>
      
     
        <!-- <img
            :src="img"
            class="miniatura"
          >
          <div class="miniatura_delimit" />  -->
      <!-- <div>
        <img v-bind:src="img">
      
      -->
     
  
    </div> 

     <iframe
      ref="iframe"
      src=""
      style="display:none"
    />
   
    <div v-show="active_paint">
       
       <input type="color" v-model="color" id="color" style="display:none" >
        <input type="range"  v-model="grosor" id="grosor"  min="1" max="10" value="1">

  </div>

  </div>
  
</template>

<script>
import Vue from 'vue'
import BEditableTable from 'bootstrap-vue-editable-table'
import pincelTable from './PincelData.vue'
import vSelect from 'vue-select'
import InputColorPicker from 'vue-native-color-picker'
import Swal from 'sweetalert2'
import {
  BButton, BFormCheckbox, BFormSelect, BFormGroup, BFormSpinbutton, BCard, BTabs, BTab, BTable,BFormInput
} from 'bootstrap-vue'
import 'vue-select/dist/vue-select.css'
import store from '@/store/index'
import axios from 'axios'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import Loading from 'vue-loading-overlay'
import MarkerEdition from './MarkerEdition.vue'
import PaintEdition from './PaintEdition.vue'
import 'vue-loading-overlay/dist/vue-loading.css'
import patient_json from '../Files/patient_ids.json'
import EditPaintObject from './EditPaintObject.vue'
import CustomSlider from "vue-custom-range-slider";
  // import the styling, css or scss
  import "vue-custom-range-slider/dist/vue-custom-range-slider.css";
  import { VBTooltip  } from 'bootstrap-vue'
const { url, port, auth } = store.state.appConfig.api

const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}
export default {
  components: {
    vSelect,
    Cropper,
    BButton,
    BFormCheckbox,
    Loading,
    BFormSelect,
    BFormGroup,
    CustomSlider,
    BFormSpinbutton,
    InputColorPicker,
    pincelTable,
    BCard,
    BEditableTable,
    BTabs, 
    BTab, 
    BTable,
    BFormInput,
  
    
  },
  
  directives: {
    'b-tooltip': VBTooltip,
 
  },
  props: {
    data: {
      required: true,
      type: [Object, String],
      default: null,
    },
    params: {
      required: true,
      type: [Object, String],
      default: null,
    },
    downloadSettings: {
      required: true,
      type: [Object, String],
      default: null,
    },
    id: {
      required: true,
      type: Number,
      default: 0,
    },
    task: {
      required: true,
      type: [Number, String, Object],
      default: 0,
    },
    server: {
      required: true,
      type: String,
      default: '',
    },
    image: {
      required: false,
      type: [Object, String],
      default: null,
    },
    update: {
      required: true,
      type: Number,
      default: 0,
    },
    tabUpdate: {
      required: true,
      type: Number,
      default: 0,
    },
    refreshTab: {
      required: true,
      type: Function,
      default: () => {},
    },
    tabId: {
      required: true,
      type: Number,
      default: 0,
    },
    show_marker:{
      type: Boolean,
      default: true
    },
    viewer_cont:{
      type: Number,
      default: 0
    },
    edit_role:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      servers: [],
      hasServer:'',
      newsaturation: "sss",
      FileReaderSync : false,
      nerea : false,
  
      fields: [
      {
        key: 'id', label: '', type: 'text', editable: false, sortable: true,
      },
      {
        key: 'selected', label: '', type: 'text', editable: false, sortable: true,
      },
      {
        key: 'color', label: '', type: 'text', editable: false, sortable: true,
      },
        {
        key: 'name', label: 'Name', type: 'text', editable: true, sortable: true,
      },
     
      {
        key: 'object_type', label: 'Type', type: 'text', editable: false, sortable: true,
      },
      
      {
        key: 'draw_inside', label: '', type: 'text', editable: false, sortable: true,
      },
      {
        key: 'show_square', label: '', type: 'text', editable: false, sortable: true,
      },
    
      {
        key: 'remove', label: '', type: 'text', editable: false, sortable: true,
      },
     
      ],
      round_text: '',
      group_zoom: [],
      is_zoom:false,
      actual_scene: '',
      blocked_group:false,
      actual_type:'',
      actual_slide:'',
      dig_recs : [],
      waiting_for_image: false,
      dig_rec : null,
      image_moment: '',
      markerSelected: [],
      markerColors: {},
      typeChange: false,
      markerTmpColor: {},
      slide: null,
      scene: null,
      show_more_options:false,
      show_paint_objects:false,
      checkTimeout:null,
      paint_tooltip:[],
      rounds_popup:false,
      colorPicker:'',
      paintSelect:'',
      just_this: false,
      checkTimeout2:null,
      show_label:'Show',
      type: null,
      disabled: false,
      isWorking: false,
      stencilProps: {
        movable: false,
        resizable: false,
        height: 1000,
        handlers: {
          eastNorth: false,
          north: false,
          westNorth: false,
          west: false,
          westSouth: false,
          south: false,
          eastSouth: false,
          east: false,
        },
      },
   
      patient_ids: [],
      patient_id: '',
      markerColors:[],
      background_image:0,
      cropExec: false,
      imgs: '',
      visible: false,
      cropper: {},
      index: 0,
      img: '',
      img_thumb: '',
      send_data: false,
      imgOpacity: 0,
      coordinates: '',
      makerefresh: false,
      resetDone: false,
      size: '',
      totalsize: '',
      imageRestriction: 'none',
      anchor: [],
      canvas: '',
      hiddenClass: '',
      box: [],
      oCoords: [],
      patient_text: '',
      result: {},
      resizeImage: false,
      isLoading: false,
      defSize: { width: 0, height: 0 },
      updateMarkers: 0,
      updateObjects: 0,
      newtask: this.task,
      imageProps: {},
      imageSize: null,
      imageRegion: null,
      marker_popup:false,
      minmap: [0, 0, 0, 0],
      markerTit: 'MARKERS',
      legend: 'E',
      legendOptions: [{ value: 'E', text: 'Right' }, { value: 'W', text: 'Left' }],
      scale: 0.6,
      scalepos: 'NW',
      scaleposOptions: [{ value: 'NW', text: 'Top Left' }, { value: 'NE', text: 'Top Right' }, { value: 'SW', text: 'Bottom Left' }, { value: 'SE', text: 'Bottom Right' }],
      timeout: null,
      unblocked: true,
      roundSelected: null,
      roundText: null,
      rounds_popup:false,
      scene_block: true,
      is_initial:1,
      text : patient_json,
      canvas1: '',
      color: '#008000',
      grosor: 8,
      ctx:'',
      rect:'',
      final_coordenates:[],
      final_coordenates_2:[],
      moment_coordinates:{},
      dibujando:false,
      heightCanv:0,
      widthCanv:0,
      active_paint:false,
      paint_options:['Main Object','A hair','Ácaro'],
      show_color_modal:false,
      actual_paint_mode: 'Main Object',
      paintObjects:[],
      actual_region:[],
      moving:false,
      image_loaded:false,
      is_pushed:false,
      show_th: true,
      tooltip_display:false,
      pincelInputData: []
   
    }
  },
  computed: {
    types() {
      const data = JSON.parse(this.data)
      try{
         return Object.keys(data)
      }catch{
        return []
      }
     
     
    },
    slides() {
      if (this.type !== null && this.type !== '') {
        const data = JSON.parse(this.data)
        const slides = {}
        const item = data[this.type]
        item.forEach(element => {
          if (slides[element.slide] === undefined) {
            slides[element.slide] = {}
          }
          if (slides[element.slide][element.scene] === undefined) {
            slides[element.slide][element.scene] = []
          }
          slides[element.slide][element.scene].push({ marker: element.marker, path: element.path, round: element.round })
        })
        return slides
      }
      return {}
    },
    
    

   
    scenes() {

      if (this.type !== null && this.type !== '' && this.slide !== null && this.slide !== '') {

        const data = JSON.parse(this.data)
        const data_type = data[this.type]

       // var all_scenes = this.text.filter(a => a.slide_id == this.slide && a.biopsy_number == this.patient_id)
        var scenes = []
        var numArray = []
        var all_length = 0
        var get_ceros = true
        var isMinus = false
        data_type.forEach(elem => {
          console.log("ELEME", elem)
          if(elem.slide == this.slide){
            if(all_length > 0 && get_ceros == true){
              
              if(all_length != elem.scene.length){
                get_ceros = false
              }
              else{
               
                all_length = elem.scene.length
              }
            }
            else{
              all_length = elem.scene.length
            }
            /*if(numArray.includes(elem.scene) == false){
              numArray.push(elem.scene)
            }*/
         
            if((elem.scene).includes('s')){
              isMinus = true;
            }
            elem.scene = ((elem.scene.replace('s','S')).replace('jpg',''))
            if(numArray.includes(Number(elem.scene.replace('S',''))) == false){
              numArray.push(Number((elem.scene).replace('S','')))
            }
         }

        })
        
        numArray.sort(function(a, b) {
          return a - b;
        });
        numArray.forEach(elem => {
         
          var add_ceros = (all_length - String(elem).length) -1
          var new_el = String(elem)
          if(get_ceros && add_ceros > 0){
          for(var i=0; i< add_ceros;i++){
            new_el = "0" + new_el
          }}
        
          if(isMinus){
            scenes.push("s"+ new_el)
          }else{
            scenes.push("S"+ new_el)
          }
          
        })

        
        return scenes
      }
      return []
    },
    btnDisabled() {
      // const disabled = (this.type !== null || this.type !== '' || this.slide === null || this.scene === null || this.slide === '' || this.scene === '')
      return false // (disabled)
    },
    paintList(){
      var data = []
      data.push({color: '#008000',name:'Main Object'})
      data.push({color: '#ff0000',name:'Ácaro'})
      data.push({color: '#ffff00',name:'Pelo'})
    
      return data
    },
  
    markers() {
      if (this.markerColors !== undefined && this.type !== null && this.type !== '' && this.slide !== null && this.slide !== '' && this.scene !== null && this.scene !== '' && this.disabled && this.updateMarkers > -1) {
        const markers_end = []
        for (let index = 0; index < this.slides[this.slide][this.scene].length; index++) {
          const element = this.slides[this.slide][this.scene][index]
          const color = (this.markerColors[this.slides[this.slide][this.scene][index].path] !== undefined) ? this.markerColors[this.slides[this.slide][this.scene][index].path].color : '#000000'
          element.color = color
          element.name = (element.marker !== '') ? element.marker : element.round
          markers_end.push(element)
        }
         const markersSort =        markers_end.sort(function (a, b) {
            return a.name.localeCompare(b.marker);
        });
        const markers = markers_end
        return markersSort
      
      }
      return []
    },
    rounds() {
      
      if (this.type !== null && this.type !== '' && this.slide !== null && this.slide !== '' && this.scene !== null && this.scene !== '') {
        const rounds = []
        for (let index = 0; index < this.slides[this.slide][this.scene].length; index++) {
          const element = this.slides[this.slide][this.scene][index]
          rounds.push({ value: element.path, text: element.round })
        }
        rounds.sort((a, b) => {
          if (a.text > b.text) {
            return 1
          }
          if (a.text < b.text) {
            return -1
          }
          return 0
        })
        return rounds
      }
      this.roundSelected = ''
      return []
    },
    minSize() {
      if (this.imageSize !== null && this.imageSize !== undefined) {
        const h = 50
        const w = parseInt((h / this.imageSize[1]) * this.imageSize[0], 10)
        return [w, h]
      }
      
      return [0, 0]
    },
    minRegion() {
      
      if (this.imageRegion !== null && this.imageSize !== undefined) {
        const f = (this.imageSize[0]) / 50
        const mt = 0
        const ml = 0
        const x = parseInt((this.imageRegion[0] / f) + ml, 10)
        const y = parseInt((this.imageRegion[1] / f) + mt, 10)
        const w = parseInt((this.imageRegion[2] - this.imageRegion[0]) / f, 10)
        const h = parseInt((this.imageRegion[3] - this.imageRegion[1]) / f, 10)
       
        return [x, y, w, h] 
      }
      return [0, 0, 0, 0]
    },
  },
  created(){
   
   // console.log("PRUEBA MAITE SAVED",localStorage.getItem('prueba_maite'))
   // console.log("PRUEBA MAITE SAVED RESP",localStorage.getItem('prueba_maite2'))
   
  
      window.addEventListener("resize", this.onResize);
      
 

     this.intervalData =  setInterval(this.ping_table ,6000);
   
   if (this.data == null){this.isWorking = true;}
  },

  watch: {
    
   
   
    is_zoom: function(value){
      if(value == false && this.just_this == true){
         //Siempre que just_this sea true, es que solo hay que cambair este Viewer, y acaba de cambiar escena. CUando cambia de escena no esperamos a Zoom!!
        this.is_zoom = false;
      }
    },
    just_this:function(value){
      //Siempre que just_this sea true, es que solo hay que cambair este Viewer, y acaba de cambiar escena. CUando cambia de escena no esperamos a Zoom!!
      if(value == true){
        this.is_zoom = false;
      }
    },
    type: function(value){
      console.log("TYPE CHANGE", value)
      try{
        if(value == '' ){
          this.patient_id = ''
        }
      }
      catch{  this.patient_id = ''}
    },
  
    patient_id: function(value){
      try{
      
      var scenita = this.text.filter(a => a.biopsy_number == value)
      this.slide = scenita[0].slide_id
      }
      catch{
        this.slide = ''
      }
    },
    
    isLoading: function(value){
    
     //this.isLoading = false;
       if(this.type == '' || this.type == null || this.scene == '' || this.slide == ''){
          this.isWorking = false;
          this.isLoading = false;

        }
       if((this.type == 'AFS_QC' || this.type == 'REG_Markers_QC') && value == true)
        {
          if(this.markerColors == undefined){this.markerColors = []}
          if(this.markerColors.length == 0){
               this.isWorking = false;
          this.isLoading = false;
          this.waiting_for_image = false;

          }else if(this.markerSelected.length == 0){
            this.isWorking = false;
          this.isLoading = false;
          this.waiting_for_image = false;
            
          }

      
        }
      
     
    },
  
    isWorking:async function(value){
      if(this.type == '' || this.type == null || this.scene == '' || this.slide == ''){
          this.isWorking = false;
          this.isLoading = false;

        }
     
      if(value == true){
        this.isWorking = false;
        if(this.type == 'REG_Markers_QC'){
        }
        if(this.markerColors == undefined){this.markerColors = []}
        if(((this.type == 'AFS_QC' || this.type == 'REG_Markers_QC')) && (this.markerColors == undefined) || (this.markerColors.length == 0))
        {
          this.isWorking = false;
          this.isLoading = false;
          this.waiting_for_image = false;
        }
        if(this.type == undefined || this.scene == undefined || this.slide == undefined){
          this.isWorking = false;
          this.isLoading = false;

        }

			}
     
      

    },
    async roundSelected() {
      
      this.rounds_popup = false;
      await this.updateParams()
     await this.sleep(2000)
     // this.resetImg()
    },
    markerTit() {
      /* if (this.markerTit === 'ROUNDS') {
        this.markerSelected = [0]
      } */
    },
    tabUpdate() {
    //   if (this.id === this.tabId) {
        axios.get(`${url}:${port}/viewer-default-image/${this.id}`, { headers }).then(response => {
          if (response) {
            if (response.data.image !== null && response.data.image !== undefined) {
              const { image } = response.data
              this.$refs.cropper.reset()
            }
          }
        })
      // }
    },
    update() {
      const params = JSON.parse(this.params)
      if (params.type !== undefined) {
        this.type = params.type
        this.slide = params.slide
        this.scene = params.scene
        this.roundSelected = (params.round !== undefined) ? params.round : ''
        this.disabled = true
        this.newtask = this.task
        this.markerTit = (this.type === 'AFS_QC' || this.type === 'REG_Markers_QC') ? 'MARKERS' : 'ROUNDS'
      }
      
    },
    markerSelected(to) {
      const { id } = this
   
      
      axios.put(`${url}:${port}/viewer-selected-markers/${id}`, JSON.stringify(to), { headers })
    },
    type(to, from) {
      console.log("TYPE", to, from)
      if(to != null && to != '' && from != '' && from != null){
        if(this.scene == null || this.scene == ''){
          if(to === 'REG_QC' || to === 'SEG_QC'){
            this.roundSelected = ''
          }
        }
      }
       //this.patient_id = ''
      if (from !== null && to !== from) {
        this.img = ''
        this.img_thumb = ''
        this.slide = (this.slide !== null) ? null : this.slide
        this.scene = (this.scene !== null) ? null : this.scene
        this.patient_id = (this.patient_id !== null) ? null : this.patient_id
        
      }
      this.markerTit = (this.type === 'AFS_QC' || this.type ==='REG_Markers_QC') ? 'MARKERS' : 'ROUNDS'
      if(this.type == 'Digital_Reconstruction' || this.type == 'Dig_Reconst'){
        this.dig_recs = [ JSON.parse(this.data)[this.type][0][this.type]]
      }
     var patient_ids = []
    /* for(var index = 0; index < this.text.length; index++){
        patient_ids.push(Number((this.text[index].biopsy_number).replace("#","")))

     }
    this.patient_ids = []
    patient_ids = patient_ids.filter((item, i, patient_ids) => patient_ids.indexOf(item) === i);
    var order_ids =  patient_ids.sort((a,b) => {
        return a - b;
    }); 
    for(var i=0; i< order_ids.length; i++){
      this.patient_ids.push("#" + String(order_ids[i]))
    }*/
      
    },
   
    slide(to, from) {
      if (from !== null && to !== from) {
        this.scene = (this.scene !== null) ? null : this.scene
      }
      /* if(this.slide != null && this.slide != ''){
         var scenita = this.text.filter(a => a.slide_id == this.slide)
         this.patient_id = scenita[0].biopsy_number
    }*/
   /* else{
      if(this.patient_id !=  ''){
       // var ids = this.text.filter(a => a.biopsy_number == this.patient_ids)
     // this.slide = ids[0].slide_id

      }
    }*/
    
    
    },
   async scene(to, from) {

    
       try{
       await this.updateParams()
      
    
        if(this.type === 'REG_QC' || this.type === 'SEG_QC' || this.type === 'Dig_Reconst'){
          if(this.roundSelected == '' || this.roundSelected == null){
            this.roundSelected = this.rounds[0].value
            this.setSlideSceneOther()
       
         //   this.resetImg()
            return
          }
          
        }
    
          if (this.type === 'AFS_QC' || this.type === 'REG_Markers_QC') {
            this.waiting_for_image = false;
            
            //this.refresh_only()
           this.setSlideScene()
          }
         
           else {
            this.waiting_for_image = false;
            if((from != '' && from != null) || this.roundSelected == undefined || this.roundSelected == null || this.roundSelected == ''){
              this.roundSelected = this.rounds[0].value
            }
            this.resetImg()
           
           // this.setSlideSceneOther()
           // this.refresh_only()
          
      }
    }catch(e){}
      
      
    },

  
  },
  
  mounted() {   
  
    this.listenToKeys()
    this.mount_ws()
 
    
    
  },

  methods: {
    show_thumber(){
      if(this.show_th){
        this.show_th = false;
        return
      }
      this.show_th = true;

    },
    async waitToPaint(time, value= true){
     
      await this.sleep(time)
    
        this.image_loaded = true

        if(value && this.is_pushed){
          this.active_paint = true;
        }

        
     

    },
    listenToKeys(){
      window.addEventListener('keydown', (e) => {  
 
      if(this.$route.name == 'Viewers'){
        if (e.key == 'Meta'  || e.key== 'Control' ) {
          this.tooltip_display = false;
          if(this.img != '' && this.isLoading == false ){
            this.is_pushed = true;
           // this.moving = true;
         // this.sleep(10000)
        // this.moment_coordinates = {}
         if(this.image_loaded == false){
          this.waitToPaint(1000)
         }
         else{
          this.waitToPaint(10)
          

         }
          
          }
          else{
            console.log("Control yes but sth no")
            this.active_paint = false;
            this.image_loaded = false;
            this.is_pushed = false;
          }
        }
      
        if(e.code == 'KeyP' || e.code == 'p'){
         // console.log("TODO ES P")
         if(this.img != '' && this.isLoading == false && this.image_loaded == true ){
         this.tooltip_display = true;
         if(this.active_paint == false && this.show_paint_objects == false){
          this.active_paint = true;
         this.moment_coordinates = {}
         
          this.setPincelContent()

         }
        }
      
        }
     
       
      }
    
    });
    window.addEventListener('keyup', (e) => {
     
      if(this.$route.name == 'Viewers'){
        this.active_paint = false;
        this.paint_tooltip = []
        this.tooltip_display = false;
        //this.moment_coordinates = {}
       
        if (e.key == 'Meta' || e.key== 'Control')  {
          this.is_pushed = false;
            if( this.dibujando ){ 
              this.active_paint = false;
              this.endDrawing(e) }
            else{ this.active_paint = false; }
        }
      
    }
     
    }); 

    },
    mount_ws()
    {
      const wsConnection = new WebSocket(`wss://ws.milan-tool.com/webtool_${this.task}/?auth=7303cdd4eb9991cad8d7bd70240b3b20.c14547c17e3db969033e8e4a5fa16f27.8eddb3797212cedc470043e1d3686176`)
    
    wsConnection.onmessage = event => {
        const json = JSON.parse(event.data)
        console.log("VIEWER JORGE Mounted","json_"+this.task, json.task)
        
        if(json.task == 'load_image'){
          this.change_image(json.image, json.data)
          //this.$root.$refs.viewer.load_viewer_image(json.image, json.task_id, json.data)
        }
        if(json.task == 'viewer_forced_done'){
          this.isLoading = false;
        }
       
      }
    try{
      const params = JSON.parse(this.params)
      const downloadSettings = JSON.parse(this.downloadSettings)
      this.legend = downloadSettings.legend
      this.scale = downloadSettings.scale[4]
      let scalepos
      switch (downloadSettings.scale) {
        case [50, 200, 0, 0, this.scale]:
          scalepos = 'NW'
          break
        case [2800, 200, 0, 0, this.scale]:
          scalepos = 'NE'
          break
        case [50, 3000, 0, 0, this.scale]:
          scalepos = 'SW'
          break
        case [2800, 3000, 0, 0, this.scale]:
          scalepos = 'SE'
          break
        default:
          scalepos = 'NW'
          break
      }
      this.scalepos = scalepos
      if (params.type !== undefined) {
        this.type = params.type
        this.slide = params.slide
        this.scene = params.scene
        
        //this.round = params.round
      
       // this.patient_id = params.patient_id
        this.roundSelected = (params.round !== undefined) ? params.round : ''
        if(params.selectedMarkers != []){

        const markSel =  (params.selectedMarkers !== undefined) ? params.selectedMarkers : []
        var newMarkSel = []
        for(var i=0; i< markSel.length;i++){
          if((newMarkSel.includes(markSel[i])) == false){
            newMarkSel.push(markSel[i])
          }
        }
        this.markerSelected = newMarkSel
       
        this.markerColors = (params.markers !== undefined) ? params.markers : []}
        this.disabled = true
        this.markerTit = (this.type === 'AFS_QC') ? 'MARKERS' : 'ROUNDS'
      }
    }
    catch(error){
      console.log("ERRRORR", error)
      this.mount_ws();
    }
  
    this.setCanvas()
    },
    is_moving(value, event){
      event.preventDefault();
      
      this.moving = value;
    },
   
    setCanvas(){
      this.canvas1 = this.$refs['canvas' + this.task]
      var canvWidth = 0.4 * window.innerWidth;
      this.canvas1.width = canvWidth;
      this.canvas1.height = canvWidth;
      this.ctx = this.canvas1.getContext('2d')
      this.rect = this.canvas1.getBoundingClientRect();

      
      this.ro = new ResizeObserver(this.onResize)
      this.ro.observe(this.$refs['canvas' + this.task])
    

    },
  
    updateValue(id, value, name){
   
   const data = {
     color: value,
     name: name
   }
    axios.put(`${url}:${port}/viewer-update-object-paints/${id}`, JSON.stringify(data), { headers }).then(async response => {
      if (response) {

      }
    }).catch(err =>{
        console.log(err)
      })
   
 },
    hiddenPaintObjects(){
      this.show_paint_objects = false;
    },
    async showSquareObject(id, val){
      var show_s = 0
      if(val){
        show_s = 1
      }
      await axios.put(`${url}:${port}/viewer-show-square/${id}/${show_s}`, JSON.stringify({}), { headers }).then(response => {
        if (response) {
       
          return true
         
        }
      })

    },
    async drawInside(id, val){
      var show_s = 0
      if(val){
        show_s = 1
      }
      await axios.put(`${url}:${port}/viewer-draw-inside/${id}/${show_s}`, JSON.stringify({}), { headers }).then(response => {
        if (response) {
       
          return true
         
        }
      })

    },
    changeName(event, name, names){
      for(var i=0;i< pincelData.length; i++){
        if(data[i].name == actual_name){
            data[i].name = objectNameEdit
            data[i].color = colorPickerEdit
        }
      }
      this.updatePaintList()
    },
    refreshPincelData(){
      this.$parent.refreshPincelData();
    },
    async removeObject(id){
      this.paintObjects = this.paintObjects.filter(a => a.id != id)
      axios.put(`${url}:${port}/viewer-delete-object-paints/${id}`, JSON.stringify({}), { headers }).then(async response => {
        if (response) {
        
        }
      }).catch(err =>{
          console.log(err)
        })
    

    },
    refreshPincelData(){
      
      this.active_paint = false;
      this.show_paint_objects = false;
      this.dibujando = false;
          this.dibujando = false;
          
          if(this.is_zoom){
            this.blocked_group = true;
            this.refresh_only()
          }
          else{
           // this.setSlideScene()
           this.blocked_group = true;
           this.refresh_only()
          }

    },
    closePincelData(){
      this.show_paint_objects = false;
    },
    
    async showSquareObject(id, val){
      var show_s = 0
      if(val){
        show_s = 1
      }
      await axios.put(`${url}:${port}/viewer-show-square/${id}/${show_s}`, JSON.stringify({}), { headers }).then(response => {
        if (response) {
       
          return true
         
        }
      })

    },
    editPaintData(color, pk, name, draw, square, type){
     const paintList =  this.$parent.paintList;
     var paintTypes = []
     for(var i=0;i<paintList.length;i++){
      paintTypes.push(paintList[i].name)
     }
   
      const { id} = this
      const viewerTabForm = new Vue({
        ...EditPaintObject,
        parent: this,
        propsData: { actual_viewer_id: id,colorPicker: color, pk, objectName: name, draw, square, type, paintTypes },
      }).$mount()
      this.$swal({
        html: viewerTabForm.$el,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        confirmButtonText: 'Save',
        width: '40%',

      }).then(async result => {
          if (result.dismiss == undefined) {
            this.refresh_only()
            this.show_paint_objects = false;
          }
        })
    },
   async saveCoordinates(final_coordenates, name, object_type){
      const {id, path, coordinates, imageSize, type, slide, scene, patient_id, color, actual_region, grosor, roundSelected} = this
      var region = []
      try{  region = [coordinates.top, coordinates.left, coordinates.height, coordinates.width]  }
      catch{ region = [0, 0,imageSize[0], imageSize[1]]  }

      var round = ''
      try{
        if(roundSelected != '' && roundSelected != null && roundSelected != undefined){
          round = roundSelected

        } 
      }catch(e){
        round = ''
      }
      
      const data = {
        viewer_id: id,
        path: path,
        region:region,
        selected: 1, 
        coordinates: JSON.stringify(final_coordenates),
        type: type,
        slide: slide,
        scene: scene,
        patient_id: patient_id,
        color: color, 
        name: name,
        actual_region: actual_region,
        to_compute: 1,
        grosor: grosor, 
        object_type: object_type,
        round: round
      }

        await axios.post(`${url}:${port}/viewer-save-coordinates`, JSON.stringify(data), { headers }).then(response => {
        if (response) {
       
          return true
         
        }
      })
      this.dibujando = false;
          this.dibujando = false;
          this.active_paint = false;
          if(this.is_zoom){
            this.blocked_group = true;
            this.refresh_only()
          }
          else{
           // this.setSlideScene()
           this.blocked_group = true;
           this.refresh_only()
          }
       
      return false;
  
     
     
    },
    updateSelectedPaints(pk_object, value){
      axios.put(`${url}:${port}/viewer-update-selected-object/${pk_object}/${value}`, JSON.stringify({}), { headers }).then(response => {
        if (response) {
          /*this.show_paint_objects = false;
          this.dibujando = false;
          this.dibujando = false;
          this.active_paint = false;*/
        
        }
      })

    },
    updatePaintObjectColor(pk, color){
      const data = { color: color}
      axios.put(`${url}:${port}/viewer-update-object-color/${pk}`, JSON.stringify(data), { headers }).then(response => {
        if (response) {
          // this.show_paint_objects = false;
          // this.dibujando = false;
          // this.dibujando = false;
          // this.active_paint = false;
          // if(this.is_zoom){
          //   this.refresh_only()
          // }
          // else{
          //   this.setSlideScene()
          // }
        }
      })
    },
    selectPaintObjects(name, pk, color){
      var is_selected = 1
      var { paintObjects} = this
      var data = paintObjects
      var varble_i = 0
      for(var i=0;i< data.length; i++){
        if(data[i]['id'] == pk){
          varble_i = i
          if(data[i]['selected']){data[i]['selected'] = false}
          else{data[i]['selected'] = true; is_selected= 0}
        }
      }
      if(is_selected == 0){ this.paintObjects[varble_i]['selected'] = false;}
      else{ this.paintObjects[varble_i]['selected'] = true;}
      
      this.updateSelectedPaints(pk, is_selected)
    },
    handleInput(event){
      console.log(event)
    },
    setPaintMode(name,color){
      this.color = color;
      this.actual_paint_mode = name;
      this.$parent.changePaintMode(true, name, color);
    },
    colorPickerChange(color, name){
      this.actual_paint_mode = name;
      this.show_color_modal = false;
      this.color = color;
      this.$parent.changePaintMode(true, name, color);
    },
    showPaintObjects(){
      if(this.show_paint_objects){this.show_paint_objects = false}
      else{
        this.show_color_modal = false;
        this.show_paint_objects = true;}
      
    },
    changePaintValue(value, mode, color){
      value = false;
      this.active_paint = false;
     // this.show_color_modal = value;
      this.actual_paint_mode = mode;
      this.color = color;
      this.final_coordenates = []
       // this.dibujando = true;
     // this.startDrawing()
     
    },
    activePaint(){
      if( this.show_color_modal  ){
        this.show_color_modal = false
          this.active_paint = true }
      else{ this.active_paint = true;
        this.show_color_modal = true;}
      this.$parent.changePaintMode(this.show_color_modal, this.actual_paint_mode, this.color);
      
    },
    onResize(){
      try{
        var canvWidth = 0.4 * window.innerWidth;
        this.canvas1.width = canvWidth;
        this.canvas1.height = canvWidth;
        this.ctx = this.canvas1.getContext('2d')
        this.rect = this.canvas1.getBoundingClientRect();
      
     // this.$emit('resize', this.$refs['canvas' + this.task].width)
      // this.canvas1.width = this.$refs['canvas' + this.task].width
      // this.canvas1.height = this.$refs['canvas' + this.task].width;
      // this.ctx = this.canvas1.getContext('2d')
      // this.rect = this.canvas1.getBoundingClientRect();
      }catch(e){}

    },
    async endDrawing(e){
     
      if(this.dibujando === true && this.tooltip_display == false){
            var not_same = 1
            this.dibujar(this.x ,this.y , e.clientX, - this.rect.left, e.clientY - this.rect.top)
            if(this.final_coordenates[0]['x'] != this.x || this.final_coordenates[0]['y'] != this.y ){
                while(not_same == 1){
                    if(this.x > this.final_coordenates[0]['x']){ this.x = this.x -1}
                    else if(this.x < this.final_coordenates[0]['x']){this.x = this.x + 1}
                    if(this.y > this.final_coordenates[0]['y']){ this.y = this.y -1}
                    else if(this.y < this.final_coordenates[0]['y']){ this.y = this.y + 1}
                    this.dibujar(this.x ,this.y , e.clientX, - this.rect.left, e.clientY - this.rect.top)
                    if(this.final_coordenates[0]['x'] == this.x && this.final_coordenates[0]['y'] == this.y ){
                        not_same = 0
                    }

                }
            }
            
            this.x = 0;
            this.y = 0;
            this.dibujando = false;
            
           Swal.fire({
              title: 'Do you want to save the object?',
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: 'Save',
              denyButtonText: `Don't save`,
            }).then(async result => {
              if (result.isConfirmed) {
                var cont = 1
                try{
                for(var i=0;i< this.paintObjects.length;i++){
                  if((this.paintObjects[i].name).includes(this.actual_paint_mode)){
                    cont += 1
                  }
                }}catch{}
                const { actual_paint_mode} = this
                var final_name = actual_paint_mode + '' + cont
                this.paintObjects.push({name: final_name, color: this.color, selected: true, id:0, object_type: actual_paint_mode, show_square:false, draw_inside:false})
                this.checkPaintObjects()
                this.show_color_modal = false;
                this.active_paint = false;
              
                await this.saveCoordinates(this.final_coordenates_2, final_name, actual_paint_mode)
                this.active_paint = false;
              } else {
                this.active_paint = false;
              }
            })
      
          
          }

    },
    checkPaintObjects(){
      const { paintObjects} = this
      var type_obj = []
      var paintObj = paintObjects
      paintObj = paintObj.sort((a, b) => {
        if (a.object_type < b.object_type) {
          return -1;
        }
      });
     

      
      for(var i=0; i< paintObjects.length; i++){
        if((type_obj.includes(paintObjects[i].object_type)) == false){
            paintObj[i] =paintObjects[i]
            paintObj[i].is_first = 1
            type_obj.push(paintObjects[i].object_type)

        }else{
          paintObj[i] =paintObjects[i]
          paintObj[i].is_first = 0
       
        }
      }
    
    this.paintObjects = paintObj

    },

    continueDrawing(e){
      if(this.dibujando === true){

            this.dibujar(this.x ,this.y , e.clientX, - this.rect.left, e.clientY - this.rect.top)
            this.x = e.clientX - this.rect.left;
            this.y = e.clientY - this.rect.top;
        }
        else if(this.isLoading == false && this.tooltip_display == true){
           var tooltipSpan = document.getElementById("toop");
          
          
             var x = e.clientX - this.rect.left;
            var y = e.clientY - this.rect.top;
            tooltipSpan.style.position = 'absolute';
          
   
          tooltipSpan.style.top = (y )   +'px ';
          tooltipSpan.style.left = (x ) + 'px ';
          console.log("ENTONCES ES AQUÏ", x, y)

          var min_int_x = Math.ceil(x) -8
          var max_int_x = Math.ceil(x) + 8
          var min_int_y = Math.ceil(y) - 8
          var max_int_y = Math.ceil(y) + 8
          var not_found = true
          for(var i = min_int_x; i< max_int_x; i++){
            for(var j= min_int_y; j< max_int_y; j ++){
              var new_key = i + "**" + j
              if((this.moment_coordinates[new_key] != undefined)){
                if(this.moment_coordinates[new_key].length > 1){
                  console.log("COOOO", this.moment_coordinates[new_key])
                }
                console.log("CO", this.moment_coordinates[new_key])
              this.paint_tooltip = this.moment_coordinates[new_key][0][0]
              not_found = false;
              break;
            }
            }
          }
          if(not_found){
            this.paint_tooltip = []
          }
          
         
         
         
      
        /*  e.preventDefault();
        e.stopPropagation();

        // get the current mouse position
        var mx=parseInt(e.clientX-offsetX);
        var my=parseInt(e.clientY-offsetY);

        // test each rect to see if mouse is inside
        dragok=false;
        for(var i=0;i<rects.length;i++){
            var r=rects[i];
            if(mx>r.x && mx<r.x+r.width && my>r.y && my<r.y+r.height){
                // if yes, set that rects isDragging=true
                dragok=true;
                r.isDragging=true;
            }
        }*/
        }
      

    },
    dibujar(x1, y1, x2, y2, data = '', color = ''){

      if(this.dibujando){
      this.show_color_modal = false;
      this.show_paint_objects = false;
      this.ctx.beginPath();
      if(color != ''){
        this.ctx.strokeStyle = color
      }else{
        this.ctx.strokeStyle = this.color
      }
      
      this.ctx.lineWidth = this.grosor;
      this.ctx.moveTo(x1,y1);
      this.ctx.lineTo(x1+1,y1+1)
      this.ctx.stroke();
      this.ctx.closePath()
      var canvWidth = 0.4 * window.innerWidth;

      var xf = x1 * (this.coordinates.width/ canvWidth)
      var yf = y1 * (this.coordinates.height/ canvWidth)
      
      this.final_coordenates_2.push({x: xf, y: yf})
      this.final_coordenates.push({x: x1, y: y1})
    }
    else{
    
      
      var key = (Math.floor(x1) + "**" + Math.floor(y1))
     
      var moment_coordinates = this.moment_coordinates
       
          try{
            if(moment_coordinates[key] != undefined){
              var datas = moment_coordinates[key]
              datas.push(data)
              moment_coordinates[key] = datas;
            }
            else{
              moment_coordinates[key] = [data]
            }
          
          }
          catch{
           
          }
          this.moment_coordinates = moment_coordinates
        
        }
    
      
      
    
},
async setPincelContent(){

  
  var pincelInputData = this.pincelInputData
  const {id, path, coordinates, imageSize, type, slide, scene, patient_id, color, actual_region, grosor, roundSelected} = this
          var saved_region = []
          try{  saved_region = [coordinates.top, coordinates.left, coordinates.height, coordinates.width]  }
          catch{ saved_region = [0, 0,imageSize[0], imageSize[1]]  }
        
        const w_x = (actual_region[2] - actual_region[0]) / (saved_region[2] - saved_region[0]) 
        const w_y = (actual_region[3] - actual_region[1]) / (saved_region[3] - saved_region[1])

        var canvWidth = 0.4 * window.innerWidth;

  for(var x = 0; x < pincelInputData.length;x++){

    if(pincelInputData[x].selected == 0){
      continue
    }
 
    var prueba = JSON.parse(this.pincelInputData[x].coordinates)
    await this.sleep()
    for(var i=0; i< prueba.length;i++){

      var x1 = Math.abs((actual_region[0] - prueba[i].x)/(w_x))
      var xf = x1 /  (this.coordinates.width/ canvWidth)
      var y1 = Math.abs((actual_region[1] - prueba[i].y)/(w_x))
      var yf = y1 / (this.coordinates.width/ canvWidth)
      console.log("MAITE" , pincelInputData[[x]])
      var moment_data = [{type:pincelInputData[x].object_type, id: pincelInputData[x].id, name: pincelInputData[x].name, color: pincelInputData[x].color, grosor: pincelInputData[x].grosor, real_x:  xf, real_y: yf, draw: pincelInputData[x].draw_inside, square: pincelInputData[x].show_square}]
  
      this.dibujar(xf,yf, 0, 0, moment_data, this.pincelInputData[x].color)
    }
    this.ctx.stroke() 
   
  
}



},
    startDrawing(e){
     
      
      console.log("HELLO 1", this.paint_tooltip)
      var paint_tooltip = this.paint_tooltip
      if( this.tooltip_display == true && paint_tooltip.name != undefined){
        this.paint_tooltip = {}
        this.editPaintData(paint_tooltip.color, paint_tooltip.id, paint_tooltip.name, paint_tooltip.draw, paint_tooltip.square, paint_tooltip.type)
        
       
       
      }
      else if(this.tooltip_display == false){
        this.onResize()
       // this.ctx.clearRect(0,  0, this.canvas1.height, this.canvas1.width);

        this.final_coordenates = []
        this.final_coordenates_2 = []
        this.dibujando = true;
        this.x = e.clientX - this.rect.left;
        this.y = e.clientY  - this.rect.top;
      }

    },
    defcolor(c){  this.color = c;  },
    defgrosor(g){  this.grosor = g; },
     ping_table(){
      this.$root.$refs.apps.ping_tab(this.tabId,  this.$route.params.id)
    },
 
    remove_popup(){
      this.isWorking = false;
      this.isLoading = false;
      this.$swal({
        title: 'Are you sure?',
        text: "Selected viewer will be deleted. You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'YES',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.delVersion()
        }
      })

    },
    closeSwal(){
      this.$swal.close()
      

    },
    delVersion() {
      
     axios.delete(`${url}:${port}/viewer-tab/${this.id}`, { headers }).then(result => {
        if (result.data.error == false){ this.$parent.getdata();}
        else{
            this.isWorking = false;
            this.isLoading = false;
            this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: `Something went wrong.Please, try  it again.`,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
      
    },
    show_all_settings(){
      this.show_more_options = true;
      this.show_label = 'Hide'
    },
    refreshZoom: async function(region, main_task){
     

      
      if(region[0] != 0 || region[0] != null){this.is_zoom = true;}else{this.is_zoom = false;}
      try{
        this.waiting_for_image = false;
        this.isLoading = true;
        this.region = region;
      
        await this.setZoomFirst(this.id, main_task)
       // this.refresh_only()
      this.refresh_all(region, main_task)
      }catch(error){}
   
    },
   
   show_marker_popup(){
    if(this.marker_popup == true){this.marker_popup = false}
    else{this.marker_popup = true;}
   },
   show_rounds_popup(){
    if(this.rounds_popup == true){this.rounds_popup = false}
    else{this.rounds_popup = true;}
    
   },
    defaultPosition() {
      return {
        left: 0,
        top: 0,
      }
    },
    defaultSize() {
      var width_moment= window.innerWidth * 0.4
      const width = Math.round((this.imageSize[0] * 1300) / this.imageSize[1], 10)
      this.coordinates = {
        top: 0, left: 0, width, height: 1300,
      }
      return {
        width,
        height: 1300,
      }
    },
    manageSettings() {
      this.markerTit = 'SETTINGS'
    },
    saveSettings() {
      let scale = [50, 200, 0, 0, 0.6]
      switch (this.scalepos) {
        case 'NW':
          scale = [50, 200, 0, 0, this.scale]
          break
        case 'NE':
          scale = [2800, 200, 0, 0, this.scale]
          break
        case 'SW':
          scale = [50, 3000, 0, 0, this.scale]
          break
        case 'SE':
          scale = [2800, 3000, 0, 0, this.scale]
          break
        default:
          scale = [50, 200, 0, 0, this.scale]
          break
      }
      const data = { legend: this.legend, scale }
      axios.put(`${url}:${port}/viewer-settings/${this.newtask}`, JSON.stringify(data), { headers }).then(response => {
        if (response) {
        }
      })
      this.markerTit = 'MARKERS'
    },
    cropChange({
      coordinates, canvas, image,
    }) {
      const savedCoor = this.coordinates
      this.coordinates = coordinates
      this.canvas = canvas
      this.imageProps = image
      const f =(  image.width + 50) / 50
      const x = Math.round(coordinates.left / f, 10)
      const y = Math.round(coordinates.top / f, 10)
      const w = Math.round((image.width - coordinates.width) / f, 10)
      const h = Math.round((image.height - coordinates.height) / f, 10)
      this.minmap = [x, y, w, h]
      this.waiting_for_image = false
      this.active_paint = false;
      if (this.unblocked == false && savedCoor.top !== coordinates.top || savedCoor.left !== coordinates.left || savedCoor.width !== coordinates.width || savedCoor.height !== coordinates.height) {
         this.refresh()
      }
    
    },
   async setSlideScene() {
    if(this.active_paint){return}
   
      const project = this.$route.params.id
      const {
        type, slide, scene, id, server, patient_id
      } = this
      
      const { path, marker, round } = this.slides[slide][scene][0]
      
      
      
      const params = {
        type, slide, scene, path, marker, round, patient_id
      }
      const data = { params, tab_id: id,  server }
      if(this.waiting_for_image == true && this.just_this == false){
        return
      }
      await this.updateParams()
      //Important, cambiamos de escena, Zoom FALSE!
      this.is_zoom = false;
      axios.post(`${url}:${port}/viewer-load/${project}`, JSON.stringify(data), { headers }).then(response => {
        if (response) {
          this.isLoading = true;
          this.newtask = response.data.task
          this.disabled = true
          if(this.newtask == -1 || this.task == 0){
             this.$parent.getdata();
             return
          }
          else{
       
            this.resetImgSlides()
          }
       
       
        }
      }).catch(err =>{
       
          console.log(err)
        })
    },
    updateSelectedMarkers(markers, colors){

      var data = {selectedMarkers:markers, colors:JSON.stringify(colors)}
       const { id } = this
        axios.put(`${url}:${port}/selected-params/${id}`, JSON.stringify(data), { headers }).then(async response => {
        if (response) {
         
        }
      }).catch(err =>{
          console.log("error", err)
        })

    },
    async updateParams() {
      const { type, slide, scene, id, patient_id } = this
      const data = {  type, slide, scene, patient_id }
     
       await axios.post(`${url}:${port}/viewer-params/${id}`, JSON.stringify(data), { headers }).then(async response => {
          if (response) {
          

        }
      }).catch(err =>{
            console.log("error", err)
          })
        

      
    },
    async change_image(new_img, data_all){
     
      //Aqui recibimos la imaggen de WS

      this.image_loaded = false;
      if(this.active_paint){ console.log("RETUNR"); return }
       try{
        this.active_paint = false;
        var params = JSON.parse((JSON.parse(data_all)).data.input_data.params)
        console.log("TODO ES",(JSON.parse(data_all)).data.input_data )
        var pincelInputData = (JSON.parse(data_all)).data.input_data.pincel_data
        console.log("TODO ES", pincelInputData)
        this.pincelInputData = pincelInputData
       
    

     
       // if(params.type == this.type && params.scene == this.scene && params.slide == this.slide && this.isLoading == true){
        
          //SOlo cogemos la imagen si contiene los parámetors que queremos, y si estamos esperando a la imagen!
          try{
            
              //Esto lo he comnetado pero creo que es importante controlar que si pedimos Zoom solo plasmemos imagen de Zoom, y viceversa
              /* if(this.is_zoom == true && params.region[0] == 0){
                  return
                }*/
        }catch(e){ console.log(e)}

         
         
          this.setZoomFirst(this.id, 0) //Es para marcar que este viewer YA no depende del Zoom de otros.
          this.updateParams()
          this.group_zoom = []
          this.active_paint = false;
          this.dibujando = false;
         
           
     
          this.unblocked = false
          this.is_initial = 0;
          this.makerefresh = true
          this.opacity = 0
          this.scene_block = true;
          this.waiting_for_image = true;

          this.img = `data:image/jpeg;base64,${new_img}`
          var image = new Image()
          image.src = this.img
          
          
          
          //this.ctx.drawImage( image, 0, 0 ,6000, 6000);
          this.onResize()

          var all_data = JSON.parse(data_all)
          this.blocked_group = false; //Esta variable en false indica que podemos hacer Zoom/cambios a todos los Viewers que están en la Tab, si es =True, únicamente haría el cambio a el propio viewer
          this.updateParams()
          this.paintObjects = []
          
         
       
         this.imageRegion = params.region
        try{
            
           
            const pincel_data = all_data.data.input_data.pincel_data

            try{  
              this.paintObjects = []
              
              for(var i=0;i< pincel_data.length;i++){

                var is_selected = true
                var show_square = true
                var draw_inside = true
                if(pincel_data[i].selected == 0){ is_selected = false}
                if(pincel_data[i].show_square == 0){ show_square = false}
                if(pincel_data[i].draw_inside == 0){ draw_inside = false}

                this.paintObjects.push({name: pincel_data[i].name, color: pincel_data[i].color,selected: is_selected, id: pincel_data[i].id, object_type: pincel_data[i].object_type, show_square: show_square, draw_inside: draw_inside})
              }
              this.checkPaintObjects()
          
            }catch{
              this.paintObjects = []

            }
            try{
              const draw_moment = all_data.data.input_data.draw
              var drawKeys = Object.keys(draw_moment)
              
              this.actual_region = draw_moment[drawKeys[0]].region
            }catch(e){
              console.log(e)
              this.actual_region = []
            }

            var add_info = JSON.parse(all_data.data.input_data.additional_info_test)
            this.imageSize = add_info.other.image_size 
            
            this.actual_scene = this.scene
            this.actual_type = this.type
            this.actual_slide = this.slide
        
            this.waitToPaint(500, false)
   
        if(params.type == 'AFS_QC' || params.type == 'REG_Markers_QC'){
       
          const markSel = (params.selectedMarkers !== undefined) ? params.selectedMarkers : []
          var newMark = []
          for(var i=0;i< markSel.length;i++){
            if((newMark.includes(markSel[i])) == false){
              newMark.push(markSel[i])
            }
          }
          this.markerSelected = newMark
      
          try{
          this.markerColors =  (JSON.parse(JSON.stringify(params.markers)) !== undefined) ? JSON.parse(JSON.stringify(params.markers)) : []
          
        
           
      
        
          }catch(e){
           
              this.imageRegion = [0,0, 10000, 10000]
              this.imageSize = [10000, 10000]

          }
     

         }
         // this.markerSelected = Object.keys(this.markerColors)
     
          var new_markers = params.markers
          this.patient_id = params.patient_id
          this.$refs.cropper.reset()
          this.waiting_for_image = false;
          this.makerefresh = false
          this.unblocked = true
          this.just_this = false;
          this.isLoading = false
          this.isWorking = false
         await this.updateParams()
     
          if(this.imageRegion[0] == 0){ 
              if(this.img_thumb == ''){
                await this.sleep(600)
                this.img_thumb = `data:image/jpeg;base64,${new_img}`
              }else{
                this.img_thumb = `data:image/jpeg;base64,${new_img}`
              }
             
     
            
        }
         }catch{
                this.img_thumb = `data:image/jpeg;base64,${new_img}`
         }
         
          
           }
        //   else{
        //    await this.updateParams()
       // console.log("Not same image, we received: ", params.slide, params.scene, params.type)
      //  }

       // }
        catch(e){console.log(e)}
    
    },
   async setSlideSceneOther() {
    if(this.active_paint){return}
     
    //  this.roundSelected = this.rounds[0].value
      const {
        type, slide, scene, id, server,
      } = this
      const data = {
        type, slide, scene, path: this.roundSelected, server
      }
     await this.updateParams()
     this.isLoading = true;
     this.is_zoom = false;
       if(this.just_this == true){
        this.waiting_for_image = true;
      }
      axios.put(`${url}:${port}/viewer-change-scene/${id}`, JSON.stringify(data), { headers }).then(async response => {
        if (response) {
          this.isLoading = true;
          this.newtask = response.data.task
          if(this.task == 0){
            location.reload()
           // this.$parent.getdata();
          }
          if(this.just_this == false){ 
           
             this.resetImg() 
          }
          this.is_zoom = false;
  
        }
      }).catch(err =>{
       
          console.log(err.code)
        })

     
      
    },
    zoom(n) {
     
      console.log("Zoom")
      this.$refs.cropper.zoom(n)
    },
    async editPaintColor(item){
      try{
        const editPaintEdition = new Vue({
          ...PaintEdition,
          parent: this,
          propsData: {
            item, 
          },
        }).$mount()
        this.$swal({
          html: editPaintEdition.$el,
          showCloseButton: false,
          showCancelButton: true,
          showConfirmButton: true,
          width: '40%',
        })
      }catch{}

    },
   async editMarker(marker, path) {
      if (this.markerSelected.includes(path)) {
        const { id } = this
        const color = (this.markerColors[path] !== undefined && this.markerColors[path] !== null) ? this.markerColors[path].color : '#fff'
        const name = marker
        const brightness = (this.markerColors[path] !== undefined && this.markerColors[path] !== null) ? this.markerColors[path].filters.brightness : 1
        const contrast = (this.markerColors[path] !== undefined && this.markerColors[path] !== null) ? this.markerColors[path].filters.contrast : 1
       
        const saturation = (this.markerColors[path] !== undefined && this.markerColors[path] !== null) ? [this.markerColors[path].filters.saturation_min, this.markerColors[path].filters.saturation_max] : [0, 100]
        const { changeMarkerColor, coordinates } = this
        console.log("JON MARKERCOLORS", this.markerColors[path])

        const data = {
          marker, path, id: id, coordinates, name,
        }
        try{

        
        const markerEdition = new Vue({
          ...MarkerEdition,
          parent: this,
          propsData: {
            data, changeMarkerColor, color, brightness, saturation, contrast, name, 
          },
          
        }).$mount()
        this.$swal({
          html: markerEdition.$el,
          showCloseButton: false,
          showCancelButton: true,
          showConfirmButton: true,
          width: '40%',
        }).then(async result => {
         // this.listenToKeys()
          if (result.isConfirmed) {
            this.markerColors[this.markerTmpColor.path] = { color: this.markerTmpColor.color, name: this.markerTmpColor.name, filters: this.markerTmpColor.filters, perce_lumi_corr: 99 }
            this.updateMarkers = new Date().getTime()
            const markerInfo = { path: this.markerTmpColor.path, info: { color: this.markerTmpColor.color, name: this.markerTmpColor.name, filters: this.markerTmpColor.filters, perce_lumi_corr: 99, onlyload: false } }
           
            //var data2send = this.markerColors
           // this.updateParams()
           // const prueba_maite = {}
            //prueba_maite[this.markerTmpColor.path] =  { color: this.markerTmpColor.color, name: this.markerTmpColor.name, filters: this.markerTmpColor.filters, perce_lumi_corr: 99 }
           // console.log("PRUEBA AMITE", prueba_maite)
           // localStorage.setItem('prueba_maite', JSON.stringify(prueba_maite))
           //if(this.markerTmpColor.path != undefined){
            var response = await axios.put(`${url}:${port}/viewer-marker/${id}`, JSON.stringify(markerInfo), { headers }) 
          // }
           
           // console.log("PRUEBA MAITE REPONSE", response)
          // localStorage.setItem('prueba_maite2', JSON.stringify(response))
            this.isLoading = true;
            this.isWorking = true;
           
          // await this.sleep(3000)
           this.waiting_for_image = false;
           if(this.markerColors == undefined || this.markerColors == null){
            this.markerColors = []}

      

          if((this.markerColors.length ==  0  || this.markerColors.length == 1 ) && this.is_initial == 1){
             // this.$parent.getdata();
             await this.sleep(1000)
              //ALWAYS RELOAD
               location.reload()
        
             // this.refresh_only()
           }
           else if((this.markerColors.length ==  0  || this.markerColors.length == 1 ) && this.is_initial == 0)
           {
           this.refresh_only()
           // await this.sleep(1000)
           // location.reload()
           }
  
           else{
                 this.refresh_only()
               // await this.sleep(1000)
               // location.reload()
               
           }
       
          }
        }).catch(err =>{
            console.log(err)
        })
      }catch(e){
      console.log(e)
    }
      }
      else{
        console.log("NO EXISTE EL PATH")
      }
   
    },
  
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    changeMarker(event, value, i){
      console.log("Change marker")
    },

    changeMarkerColor(path, name, color, filters) {
      this.markerTmpColor = {
        path, color, name, filters,
      }
    },
    async setZoomFirst(id, value){
      if (value > 0){
        
      //Esta funci´pn Marca que los viewers van a tener todos el mismo Zoom que el Viewer en que hemos aplicado Zoom 
        //Ejemplo, tenemos dos Viewers task = 90 y taksk = 91, si cambiamos Zoom en el 90, cuando generamos la imagen del 91 será con el Zoom del 90
        var firstZoom = await axios.post(`${url}:${port}/viewer-set-zoom/${id}/${value}`, JSON.stringify({}), { headers })
      }

    },
    refresh_all(region, main_task) {
   
      if(this.active_paint){return}
        
        //this.isWorking = true
        this.unblocked = false
        this.isLoading = true
        this.opacity = 1000
   
        const {  id, server, newtask,  } = this
        const data = {  id, server, region: region }
        if (this.type !== 'AFS_QC' && this.type !== 'REG_Markers_QC') {
          data.round = this.roundSelected
        }
        if ((this.type == 'AFS_QC' || this.type == 'REG_Markers_QC') && this.task != 0) {
          if(this.markerColors == undefined){this.markerColors = []}
           if(this.markerColors == undefined || this.markerColors.length == 0){
               return
        }
        }
        var task2send = 0
        if(newtask == undefined) { task2send = this.task }
        else{  task2send = newtask }  
        if( this.waiting_for_image == true) {   return  } // Si ya estamos esperando a una imagen, no volvemos a pedir nada!
        this.waiting_for_image = true;
        data.main_task = main_task
        
     
        this.updateParams()
        if(region[0] == null){region[0] = 0}
        if(region[1] == null){region[1] = 0}
        if(region[0] != 0 || region[1] != 0){this.is_zoom = true;}else{this.is_zoom = false;}
        
        axios.post(`${url}:${port}/viewer-generate-image/${task2send}`, JSON.stringify(data), { headers }).then(response => {
          if (response) { 
            this.isLoading = true;
            
             if(this.task == 0){   //this.$parent.getdata();    
             }
            this.setZoomFirst(this.id, 0)
        
            this.isLoading = true;
            if(response.data.error == "Cannot convert undefined or null to object"){
             // this.isLoading = false
              this.refresh_only()
            }
      
            this.waiting_for_image = true;
          }
        }).catch(err =>{

        })
      // }
    },
    async  refresh_only() {

      if(this.active_paint) { return}
   

        //SOLO hacemos refresh del VIEWER actual, no de todos que están en el tab!
        
       // this.isWorking = true
        this.unblocked = false

        const {
          id, server, newtask, task
        } = this
        try{

        
        var data = {
          id, server, region: [this.coordinates.left, this.coordinates.top, this.coordinates.width, this.coordinates.height],
        }}
        catch(e){
          data = {
          id, server, region: [null, null, null, null],
        }
        }
        if (this.type !== 'AFS_QC' && this.type !== 'REG_Markers_QC') {
          if(this.roundSelected == null || this.roundSelected == undefined){
            data.round = []
          }else{
            data.round = this.roundSelected 
          }
         
        }
        this.waiting_for_image = false;
      
        var task2send = 0
        if(newtask == undefined || newtask == null) { task2send = this.task }
        else{ task2send = newtask }
        
            
        this.scene_block = false;
        if(this.waiting_for_image == true){  return  }
        this.waiting_for_image = true;
        if ((this.type == 'AFS_QC' || this.type == 'REG_Markers_QC') && this.task != 0) {
          if(this.markerColors == undefined){this.markerColors = []}
           if(this.markerColors == undefined || this.markerColors.length == 0){
         // return
        }
        }
       await this.updateParams()
        try{
          if(this.coordinates.left == null){this.coordinates.left = 0}
          if(this.coordinates.top == null){this.coordinates.top = 0}
          if(this.coordinates.left != 0 || this.coordinates.top != 0){this.is_zoom = true;}else{this.is_zoom = false;}
        }catch(e){

        }
       
        axios.post(`${url}:${port}/viewer-generate-image/${task}`, JSON.stringify(data), { headers }).then(async response => {
          if (response) {
        
            this.isLoading = true;
        
             if(this.task == 0 ){
            //  this.$parent.getdata();
            }
           this.isLoading = true;
          
            }
          
          await this.updateParams()
         
        }).catch(err =>{
          console.log(err.code)
        })
      // }
    },
   async refresh() {
    if(this.active_paint){return}
          //Aqui si hay varios viewers, se aplica a todos!
   
          if ((this.type == 'AFS_QC' || this.type == 'REG_Markers_QC') && this.task != 0) {
            await this.updateParams()
          }
        //  this.isWorking = true
          this.unblocked = false
           this.isLoading = true
          const {
            id, server, newtask,
          } = this
          try{
          var region = [this.coordinates.left, this.coordinates.top, this.coordinates.width, this.coordinates.height]
          var data = {
            id, server, region: [this.coordinates.left, this.coordinates.top, this.coordinates.width, this.coordinates.height],
          }
          }
          catch{
            data = {
                id, server, region: [null, null, null, null]
            }
          region = [null, null, null, null]
        }
        if (this.type !== 'AFS_QC' && this.type !== 'REG_Markers_QC') {
          data.round = this.roundSelected
        }
        var task2send = 0
        if(newtask == undefined) {task2send = this.task}
          else{task2send = newtask}
          var tab_active = localStorage.getItem('tab_id')
            if(this.viewer_cont > 0 && this.waiting_for_image == false && this.blocked_group == false){ 
                    this.scene_block = true;
                    this.$parent.change_all(task2send, region)
                  }
              this.blocked_group = false;
              this.scene_block = false;
              if(this.waiting_for_image == true){
                // return
              }
                this.waiting_for_image = true;
        
     await this.updateParams()
     try{

     
      if(this.coordinates.left == null){this.coordinates.left = 0}
        if(this.coordinates.top == null){this.coordinates.top = 0}
        if(this.coordinates.left != 0 || this.coordinates.top != 0){this.is_zoom = true;}
        }catch{this.is_zoom = false;}
        axios.post(`${url}:${port}/viewer-generate-image/${task2send}`, JSON.stringify(data), { headers }).then(response => {
          if (response) {
     
          this.isLoading = true;
           this.setZoomFirst(this.id, 0)
          
            if(this.task == 0){
           this.isLoading = true;
            }
              if ((this.type == 'AFS_QC' || this.type == 'REG_Markers_QC') && this.task != 0) {
      
        }
            }
            this.makerefresh = false
            this.unblocked = true
            this.isWorking = false;
     
        }).catch(err =>{
          console.log(err.code)
       
         
        })
      // }
    },
    resetImgAll(){
      this.scene_block = false;
      this.send_data = true;
      if(this.active_paint){return}
    
      this.resetImg()

    },
    checkParams(params){
      try{
      if(params.slide != this.slide || params.scene != this.scene || params.type != this.type){
       //this.waiting_for_image = false;
        if (this.type === 'AFS_QC' || this.type === 'REG_Markers_QC') {
       // this.setSlideScene()
       //this.refresh_only()
        } else {
          this.isLoading = true;
          //this.setSlideSceneOther()
         // this.refresh_only()
        }
        return false
      }

      return true
      }
      catch{
        return true
      }


    },
   async resetImg() {
    if(this.active_paint){return}
      
        //this.isWorking = true
        this.isLoading = true
        this.unblocked = false
        this.opacity = 0

   
        const {
          id, server, newtask,
        } = this
        const data = {
          id, server, region: [null, null, null, null],
        }
        if (this.type !== 'AFS_QC' && this.type !== 'REG_Markers_QC'){
          if(this.is_initial == 1){
           // this.is_initial = 0
           this.waiting_for_image = false;
            //this.setSlideScene()
           // this.refresh_only()
           // return
          }
          data.round = this.roundSelected
          if(this.is_initial == 1){
            //this.is_initial = 0
            this.waiting_for_image = false;
           // this.setSlideSceneOther()
            //this.refresh_only()
           // return
          }
        }
        
        var task2send = 0
        if(newtask == undefined) {task2send = this.task}
      else{task2send = newtask}
    
      
     if(this.waiting_for_image == true){
        return
      }
        this.waiting_for_image = true;
           if(this.viewer_cont > 0  && this.scene_block == false && this.send_data == true && this.is_initial != 1){ 

            this.scene_block = true;
            this.$parent.change_all(task2send, [null, null, null, null])
            this.send_data = false;
        }
       
        this.scene_block = true;
        this.is_initial = 0;
        if ((this.type == 'AFS_QC' || this.type == 'REG_Markers_QC') && this.task != 0) {
          if(this.markerColors == undefined){this.markerColors = []}
           if(this.markerColors == undefined || this.markerColors.length == 0){
          return
        }
        }
     await  this.updateParams()
      this.is_zoom = false;
      try{
        this.isLoading = true;
        await axios.post(`${url}:${port}/viewer-generate-image/${task2send}`, JSON.stringify(data), { headers }).then(response => {
          if (response) {
            this.isLoading = true;
            if(this.task == 0){
              // this.$parent.getdata();
              }

             this.isLoading = true;
         
            
          }
        }).catch(err =>{
          console.log("error", err)
            if(this.task == 0){
           //  this.$parent.getdata();
            }
    
        })
      // }
      }catch(e){
        console.log(e)
      
      }
      if(this.task == 0 && this.scene != '' && (this.type == 'REG_QC' || this.type === 'SEG_QC')){
      // await this.sleep(1000)
        location.reload()
      }
      


    },

   async resetImgSlides() {
  
      //  this.isWorking = true
        this.unblocked = false
        this.opacity = 0
        // console.log('resetImg')
        const {
          id, server, newtask,
        } = this
        const data = {
          id, server, region: [null, null, null, null],
        }
        if (this.type !== 'AFS_QC' && this.type !== 'REG_Markers_QC') {
          data.round = this.roundSelected
        }
        
        var task2send = 0
        if(newtask == undefined) {task2send = this.task}
      else{task2send = newtask}
  
    if(this.waiting_for_image == true){ return } // Es que ya hay una llamada realizada y estamos esprando a recibirla
     this.waiting_for_image = true;
   
      await  this.updateParams()
        this.is_zoom = false;
        this.isLoading = true;

      
        axios.post(`${url}:${port}/viewer-generate-image/${task2send}`, JSON.stringify(data), { headers }).then(response => {
          if (response) {
            this.isLoading = true;
             if(this.task == 0){
             //location.reload()  }
             if(response.data.error == "Cannot convert undefined or null to object" && this.type == 'AFS_QC'){
             // this.isLoading = false;
              }
             }
            
          }
        }).catch(err =>{
          console.log(err)
    
           if(this.isLoading == true && this.isWorking == true){
           //  this.resetImgSlides()

          }
          
          
        })
      // }
    },
    downloadImg() {
      this.isLoading = true
      const {
        id, server, newtask,
      } = this
      var serv = server
      const data = {
        id, server: serv
      }
      var task2send = 0
      if(newtask == undefined) {task2send = this.task}
      else{task2send = newtask}

      axios.post(`${url}:${port}/viewer-download-image/${task2send}`, JSON.stringify(data), { headers }).then(response => {
        if (response) {
          const { img } = response.data
          this.isLoading = false
           this.$refs.iframe.src = `https://ws.milan-tool.com/viewer-download/${img}`
          //this.$refs.iframe.src = `https://milan-tool.com/viewer-download/${img}`
        }
      })
    },
    hideCrop() {
      this.hiddenClass = 'cropHidden'
      this.resizeImage = true
      this.cropper = this.coordinates
      this.resizeCrop(this.oCoords[2], this.oCoords[3], 0, 0)
      this.imageRestriction = 'fill-area'
      this.stencilProps = {
        handlers: {},
        movable: false,
        resizable: false,
        width: 500,
      }
    },
    showCrop() {
    
      this.hiddenClass = ''
      this.resizeImage = false
      this.resizeCrop(this.cropper.width, this.cropper.height, this.cropper.left, this.cropper.top)
      this.imageRestriction = 'fit-area'
      this.stencilProps = {
        movable: true,
        resizable: true,
        width: 500,
      }
    },
    resizeCrop(width, height, left, top) {
      
      this.$refs.cropper.setCoordinates({
        width,
        height,
        left,
        top,
      })
    },
    maximizeCrop() {
      const { cropper } = this.$refs
      // eslint-disable-next-line no-unused-vars
      const center = {
        left: cropper.coordinates.left + cropper.coordinates.width / 2,
        top: cropper.coordinates.top + cropper.coordinates.height / 2,
      }
      cropper.setCoordinates([
        // eslint-disable-next-line no-unused-vars
        ({ coordinates, imageSize }) => ({
          width: imageSize.width,
          height: imageSize.height,
        }),
        // eslint-disable-next-line no-unused-vars
        ({ coordinates, imageSize }) => ({
          left: 0,
          top: 0,
        }),
      ])
    },
   async changeSceneClick(sum) {
      const pos = this.scenes.indexOf(this.scene)
      // eslint-disable-next-line no-nested-ternary
      this.is_zoom = false;
      this.blocked_group = true;
      const newpos = ((pos + sum) === -1) ? 0 : (((pos + sum) >= this.scenes.length) ? this.scenes.length - 1 : (pos + sum))
      this.scene = this.scenes[newpos]
     await this.updateParams()
      if(this.viewer_cont > 0){
         this.$parent.change_scene_parent(this.task, this.scenes[newpos])}
      // // console.log(sum, pos, newpos)
    },
  async  changeSceneNew(new_scene) {

     
      if(this.scenes.includes(new_scene) && this.scene != new_scene){
        await this.updateParams()
        this.just_this = true;
        this.is_zoom = false;
        this.waiting_for_image = false;
        this.scene = new_scene
        const pos = this.scenes.indexOf(this.scene)
        this.scene = this.scenes[pos]
        this.scene_block = true;
      }
   
    

    },
    changeScene(sum) {
      const pos = this.scenes.indexOf(this.scene)
      const newpos = ((pos + sum) === -1) ? 0 : (((pos + sum) >= this.scenes.length) ? this.scenes.length - 1 : (pos + sum))
      this.scene = this.scenes[newpos]
    

    },
    changeRound(sum) {
     
      const rounds = this.rounds.map(round => round.value)
      
      const pos = rounds.indexOf(this.roundSelected)
      const newpos = ((pos + sum) === -1) ? 0 : (((pos + sum) >= rounds.length) ? rounds.length - 1 : (pos + sum))
      this.roundSelected = rounds[newpos]
      
    },
   
    imgReady() {
      this.imgOpacity = 1
    },
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.wrap{
  /* background-color: #fff; */
  padding: 2rem 3rem;
  text-align: center;
  color: #fff;
  border: 3px solid #fff;
  box-shadow: 0px 0px 25px #222;
  backdrop-filter: blur(10px);

}

#viewer {
  border: 1px solid #0000003d;
  height: 40vw + 37px;
  margin-top: 30px;
  /* width: 100%; */
  width: 40vw;

  /* max-width: 1400px; */
  /* margin: 10px 100px 10px 100px; */
  /* height: 639px;
  width: 639px; */
}


#viewer #head {
  border-bottom: 1px solid #0000003d;
  /* height: 74px; */
  display:flex;
  flex-direction: row;
  justify-content: inherit;
  
}
#viewer #content {
  height: 40vw;
  margin-top: 1px;
  /* width: 100%; */
  width: 40vw;
  display: flex;
  justify-content: space-between;
}
#viewer #picture {
  /* height: 600px;
  width: 601px; */
  /* height: 100%;
  width: 100%; */
  /* height: 40vw;
  margin-top: 1px;
  /* width: 100%; */

  height: 100%;
  width:100%;
  background-color: black;
  border-right: 1px solid #0000003d;
  justify-content: center;
  /* width:calc(100%); */
  /* background-color: #e8e9ea; */
  border-right: 1px solid #0000003d;
  justify-content: center;
  /* background: #000; */
  /* background-image: var(--image_moment); */

}
#viewer #picture_all {
  /* height: 100%;
  width: 100%; */
  height: 40vw;
  margin-top: 1px;
  /* width: 100%; */
  width: 40vw;
  /* width:calc(100%-200px); */
  background-color: #e8e9ea;
  border-right: 1px solid #0000003d;
  justify-content: center;
  background: #000;
  
 

}
.vue-advanced-cropper__image{
  /* display: inline-block;
  position:absolute; */
}
.vue-rectangle-stencil {
  position: relative;
}
#viewer #slides {
    display: flex;
    /* width: 50%; */
    padding: 2px;
   
}
#viewer #buttons{
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    /* justify-content: flex-start; */
    width: 25%;
  padding: 2px
}
.canvas-pict{
  height: 40vw;
 
  /* width: 100%; */
  width: 40vw;

}
#viewer #paints{
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-end;
    width: 25%;
    align-items: center;
    position: absolute;
    
}
 #viewer #markers{
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-end;
    width: 25%;
    align-items: center;
    position: absolute;
    
}
#viewer #markers div{
    width: 200px;
  border-left: 1px solid #0000003d;
  height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
}
#viewer #paint-content{
  position: absolute; 
    max-height: 40vw;
    width: auto;
    overflow-y: auto;
    background-color: white;
    padding-bottom: 10px;
    padding-right: 10px;
} 
#viewer #marker-content{
  position: absolute; 
    max-height: 40vw;
    width: 200px;
    overflow-y: auto;
    background-color: white !important;
}  
#viewer #settings-content{
    width: 200px;
    overflow-y: auto;
    padding:15px;
    display:none;
}
#viewer #marker-content div.marker{
padding: 5px 10px;
display: inline-flex;
    align-items: center;
    width: 100%;
    cursor: default;
}
#viewer #paint-content div.paint{
padding: 0px 10px;
display: inline-flex;
    align-items: center;
    width: 100%;
    cursor: default;
}
#viewer #marker-content div.marker-color{
    width: 14px;
    height: 14px;
    display:block;
    border: 1px solid #0000003d;
    margin-right: 10px;
}
#viewer #paint-content div.paint-color{
    width: 14px;
    height: 14px;
    display:block;
    border: 1px solid #0000003d;
    margin-right: 10px;
}
#viewer #paint-content div.paint .pointer{
    cursor:pointer!important;
    opacity:1 !important;
}
#viewer #paint-content div.paint :not(.pointer)  {
  /* opacity: 0.5; */
}
#viewer #paint-content div.paint .paint-color:not(.pointer)  {
    /* background: #1f1f1f3d !important; */
} 


#viewer #marker-content div.marker .pointer{
    cursor:pointer!important;
    opacity:1 !important;
}
#viewer #marker-content div.marker :not(.pointer)  {
  opacity: 0.5;
}
#viewer #marker-content div.marker .marker-color:not(.pointer)  {
    background: #1f1f1f3d !important;
} 

.btn-outline-gray {
    border:1px solid rgba(60,60,60,.26) !important;
    background-color: transparent;
    padding: 5px
}
.btn-outline-gray:not(:disabled):not(.disabled):hover {
    color: #fff;
    background: #6e6b7b94;
}
.vue-advanced-cropper {
    /* height: auto;
    width:40vw !important; */
     /* width: 40vw !important; */
   /* height: 40vw !important;
   width: auto !important; */
   /* background-color:black; */
}
.vue-advanced-cropper__foreground {
    opacity: 1;
    background-color: none;
    display: none;
}
.vue-rectangle-stencil{
  /* height: 40vw;
  margin-top: 1px;

  width: 40vw; */
  /* width: 40vw !important; */
  /* width:auto;
  height: auto; */
   /* height: 40vw !important; */
   border:1px solid yellow;
   /* height: 40vw; */
   /* width: auto;
   height: auto; */
   /* display:none; */
   /* position:absolute; */
/*    
   display: block  */
  /* display:none !important; */

}


.vue-advanced-cropper__foreground{
  /* display: none; */
}
.minmap{
  display: block;
  padding: 10px;
}
.miniatura{
  display: block;
  margin-top: 0px;
  position: absolute; 
  margin-left: 0px;
  margin-right: 0px;
  border:1px solid white;
  background: black;
}
.miniatura_delimit{
  display: block;
  position:absolute;
  /*position: absolute;*/
  border:1px solid red;
}
.floatingMap{
  /*width: 100%;*/
  width: auto;
  position:absolute;
  margin-top: -70px;
  display: flex;
  flex-direction: row-reverse;
  padding-right: 200px;
  right: 0;
}
.vue-advanced-cropper__boundaries, .vue-advanced-cropper__backgrouns{
  /* transition:none!important; */
  /* height: 40vw;
  margin-top: 1px;

  width: 40vw; */

}
.vue-preview__wrapper{
  height: 40vw  !important;
  width: auto !important;
}
.swal2-select {
    display: flex;
    width: 100%;
    margin-top: 10px;
}

.markerDisabled{
  background:#0000000f!important;
}
.icp__input {
    height: 15px !important;
    width: 15px!important;
}
#top1{
  position:relative;
}
#toop{
  z-index: 98987987;
  background-color: transparent;
  color: white;
  max-width: 100px;
  margin-top:-50px;
  border-color: 1px solid grey;
  color:black;
  

  
}



</style>
